import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Selectors
// @ts-ignore
import { makeSelectPickTypeValue } from '../../services/pickTypes/selectors';

interface OwnProps {
    pickTypeId: number;
}

interface ConnectedProps {
    name?: string;
}

type Props = OwnProps & ConnectedProps;

export class PickTypeNameValueComponent extends React.PureComponent<Props> {
    render(): string | null {
        const { name } = this.props;

        if (!name) {
            return null;
        }

        return name;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    name: makeSelectPickTypeValue('name')
});

export default connect(mapStateToProps)(PickTypeNameValueComponent);
